'use client'

import { useState, useEffect } from 'react'
import styles from './RateTranslation.module.scss'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import ThumbsUpDownOutlinedIcon from '@mui/icons-material/ThumbsUpDownOutlined'
import Rating from '@mui/material/Rating'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import { PATHWAY } from '@/modules/httpService'
import Snackbar from '@mui/material/Snackbar'
import { useTranslations } from 'next-intl'

function RateTranslation ({ slug }: { slug: string }) {
  const [modalOpen, setModalOpen] = useState(false)
  const [form, setForm] = useState<{ rating: number, selected: string[] }>({ rating: 2, selected: [] })
  const [snackbar, setSnackbar] = useState('')

  const t = useTranslations('RateTranslation')

  function handleCancel () {
    setForm({ rating: 2, selected: [] })
    setModalOpen(false)
  }

  async function updateServer (step: string) {
    try {
      await PATHWAY.put('/feedback', {
        step,
        slug,
        rating: form.rating,
        sections: form.selected
      })

      if (step === 'form-submit') {
        setSnackbar(t('feedback-submitted'))
        setForm({ rating: 2, selected: [] })
        setModalOpen(false)
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        console.error(err.message)
        setSnackbar(t('error'))
      }
    }
  }

  useEffect(() => {
    if (modalOpen) {
      updateServer('form-open')
    }
  }, [modalOpen])

  return  (
    <>
      <div className={styles.wrapper}>
        {/* <div className={styles.title}>Feedback</div> */}
        <div className={styles.flex}>
          <div className={styles.buttons}>
            <Stack spacing={2} direction="row">
              <Button
                variant="outlined"
                size="small"
                style={{ textTransform: 'none' }}
                startIcon={<ThumbsUpDownOutlinedIcon />}
                onClick={() => setModalOpen(true)}
              >
                {t('submit-feedback')}
              </Button>
            </Stack>
          </div>
        </div>
      </div>
      <Dialog
        open={modalOpen}
        onClose={() => handleCancel()}
      >
        <DialogTitle>{t('translation-feedback')}</DialogTitle>
        {modalOpen &&
          <div>
            <DialogContent dividers>
              <Typography component="legend">{t('overall-rating')}</Typography>
              <Rating
                name="rating"
                value={form.rating}
                style={{ marginBottom: '1rem', marginTop: '0.5rem' }}
                onChange={(e, newValue) => {
                  setForm({ ...form, rating: newValue || 2 })
                }}
              />
              <FormGroup>
                {[
                  { label: t('unintended-meaning'), slug: 'unintended-meaning' },
                  { label: t('difficult-to-understand'), slug: 'difficult-to-understand' },
                  { label: t('awkward-or-incoherent'), slug: 'awkward-or-incoherent' },
                  { label: t('too-formal'), slug: 'too-formal' },
                  { label: t('too-casual'), slug: 'too-casual' },
                  { label: t('inappropriate-or-offensive'), slug: 'inappropriate-or-offensive' }
                ].map((opt, i) => {
                  return (
                    <FormControlLabel
                      key={i}
                      control={<Checkbox checked={form.selected.includes(opt.slug)} />}
                      label={opt.label}
                      onClick={() => {
                        const exists = form.selected.includes(opt.slug)
                        if (exists) {
                          // remove existing
                          setForm({ ...form, selected: form.selected.filter(o => o !== opt.slug)})
                        } else {
                          setForm({ ...form, selected: [...form.selected, opt.slug]})
                        }
                      }}
                    />
                  )
                })}
              </FormGroup>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={() => handleCancel()}>
                {t('cancel')}
              </Button>
              <Button
                onClick={() => {
                  updateServer('form-submit')
                }}
              >
                {t('submit')}
              </Button>
            </DialogActions>
          </div>
        }
      </Dialog>
      <Snackbar
        open={snackbar !== ''}
        autoHideDuration={6000}
        onClose={() => setSnackbar('')}
        message={snackbar}
      />
    </>
  )
}

export default RateTranslation
